module.exports = __webpack_public_path__ + "static/media/3.d3e25b76.jpg";